var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"currency-component-container",style:(_vm.style)},[_c('a',{style:(_vm.style),attrs:{"href":_vm.hrefValue,"target":_vm.target}},[_vm._v(_vm._s(_vm.element.propValue ? _vm.element.propValue : '-'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }